const FREE_TRIAL_DURATION = 14;

export {FREE_TRIAL_DURATION}
